import { psCollection } from "./powersync-collection.js";
import {
  serviceSchema,
  bookingSchema,
  serviceStaffSchema,
  clientSchema,
  membershipSchema,
  serviceLoyaltyConfigSchema,
  type Service,
  type Booking,
  type ServiceStaff,
  type Client,
  type Membership,
  type ServiceLoyaltyConfig,
} from "../schemas/services.js";

export const servicesCollection = psCollection("services", serviceSchema);

export const bookingsCollection = psCollection("bookings", bookingSchema);

export const serviceStaffCollection = psCollection("service_staff", serviceStaffSchema);

export const clientsCollection = psCollection("clients", clientSchema);

export const membershipsCollection = psCollection("memberships", membershipSchema);

export const serviceLoyaltyConfigsCollection = psCollection("service_loyalty_configs", serviceLoyaltyConfigSchema);
